module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-4-photo-3-4ddd07e1329e894ccf9b8e6c28afe738.webp";